import moment from 'moment';
import _ from 'lodash';
import { getLastAck } from '@sakari-io/staza-common';

const extractAcknowledgements = (item, stages = []) => {
  // console.log('item',item);
  const type = _.pick(item.type, ['id', 'name']) || { id: 0, name: 'Unknown' };
  const result = stages.map((stage) => {
    const lastAck = getLastAck(_.get(item, ['stages', stage.id, 'acknowledgements'])) || { acknowledged: false };
    return {
      id: item.id,
      type,
      ack: lastAck,
      stage,
    };
  });

  // console.log('extract', result);

  return result;
};

const groupAcknowledgementsByTypeDateStage = (acknowledgements) => {
  return acknowledgements.reduce((res, ack) => {
    // console.log('ack',ack.ack);
    if (ack.ack.acknowledged) {
      _.update(res, [ack.type.id, moment(ack.ack.at).startOf('d').toISOString(), ack.stage.id], (acks = []) => {
        acks.push(ack);
        return acks;
      });
    }
    return res;
  }, {});
};

const groupAcknowledgementsByTypeDateEmployee = (acknowledgements) => {
  return acknowledgements.reduce((res, ack) => {
    if (ack.ack.acknowledged) {
      _.update(res, [ack.type.id, moment(ack.ack.at).startOf('d').toISOString(), ack.ack.by ? ack.ack.by.id : 0], (acks = []) => {
        acks.push(ack);
        return acks;
      });
    }
    return res;
  }, {});
};

export {
  extractAcknowledgements,
  groupAcknowledgementsByTypeDateStage,
  groupAcknowledgementsByTypeDateEmployee,
};



// WEBPACK FOOTER //
// ./src/utils/tasks.js